import { graphql } from 'react-relay';

export const mutationClientSecret = graphql`
  mutation PaymentCorpoClientSecretMutation ($corpoRef: String!) {
    payment {
      corpo {
        res: createSEPASetupIntent(corpoRef: $corpoRef) {
          code
          message
          data
        }
      }
    }
  }
`;

export const mutationSaveSepa = graphql`
  mutation PaymentCorpoSaveSEPAMutation ($corpoRef: String!, $setupIntentId: String!) {
    payment {
      corpo {
        res: saveSEPAtoCorpo(corpoRef: $corpoRef, setupIntentId: $setupIntentId) {
          code
          message
          corpoNode {
            ...layoutCorpoData
          }
        }
      }
    }
  }
`;

export const mutationSaveTransfer = graphql`
  mutation PaymentCorpoSaveTransferMutation ($corpoRef: String!, $slug: String!) {
    payment {
      corpo {
        res: saveTransfertoCorpo(corpoRef: $corpoRef, slug: $slug) {
          code
          message
          corpoNode {
            ...layoutCorpoData
          }
        }
      }
    }
  }
`;

export const mutationCardSetup = graphql`
  mutation PaymentCorpoCardSetupMutation ($corpoRef: String!) {
    payment {
      corpo {
        res: createCardSetupIntent(corpoRef: $corpoRef) {
          code
          message
          data
        }
      }
    }
  }
`;

export const mutationChangeCard = graphql`
  mutation PaymentCorpoChangeCardMutation ($input: PaymentChangeSubscriptionPaymentMethodInput!) {
    payment {
      corpo {
        res: changeSubscriptionPaymentMethod(input: $input) {
          code
          message
          data
        }
      }
    }
  }
`;

export const mutationResume = graphql`
  mutation PaymentCorpoResumeMutation ($input: PaymentResumeSubscriptionInput!) {
    payment {
      corpo {
        res: resumeSubscription(input: $input) {
          code
          message
          data
        }
      }
    }
  }
`;

// WEA-157: delete the saved subscription payment method (detach from Stripe + clear subSepaData/subCardData).
// Corpo admin only, and only when no subscription is running (enforced server-side).
export const mutationDeletePm = graphql`
  mutation PaymentCorpoDeletePmMutation ($corpoRef: String!) {
    payment {
      corpo {
        res: deleteSubscriptionPaymentMethod(corpoRef: $corpoRef) {
          code
          message
        }
      }
    }
  }
`;

export const mutationStartSubscription = graphql`
  mutation PaymentCorpoStartSubscriptionMutation ($input: PaymentStartSubscriptionInput!) {
    payment {
      corpo {
        res: startSubscription(input: $input) {
          code
          message
          data
        }
      }
    }
  }
`;

export const mutationCancelSubscription = graphql`
  mutation PaymentCorpoCancelSubscriptionMutation ($corpoRef: String!, $atPeriodEnd: Boolean, $force: Boolean) {
    payment {
      corpo {
        res: cancelSubscription(corpoRef: $corpoRef, atPeriodEnd: $atPeriodEnd, force: $force) {
          code
          message
          data
        }
      }
    }
  }
`;

export const mutationEraseAll = graphql`
  mutation PaymentCorpoEraseAllMutation ($corpoRef: String!) {
    payment {
      corpo {
        res: eraseAllPaymentMethods(corpoRef: $corpoRef) {
          code
          message
          corpoNode {
            ...layoutCorpoData
          }
        }
      }
    }
  }
`;
